import constants, { isPatientApp } from './constants';

export const Links = {
  anleitung: {
    href: isPatientApp
      ? 'https://neolexon.de/wp-content/uploads/2021/04/gebrauchsanweisung-neolexon-aphasie-app.pdf'
      : 'https://neolexon.de/wp-content/uploads/2021/04/gebrauchsanweisung-neolexon-therapeuten-app.pdf',
    label: isPatientApp
      ? 'Anleitung Patient:innen App'
      : 'Anleitung Therapeut:innen App',
  },
  impressum: {
    href: 'https://neolexon.de/impressum',
    label: 'Impressum',
  },
  datenschutz: {
    href: 'https://neolexon.de/datenschutzerklaerung',
    label: 'Datenschutz',
  },
  aphasieBrowserApp: {
    href: 'https://aphasie.neolexon.de',
    label: 'https://aphasie.neolexon.de',
  },
  therapistBrowserApp: {
    href: 'https://therapeut.neolexon.de',
    label: 'https://therapeut.neolexon.de',
  },
  agb: {
    href: 'https://neolexon.de/agb-neolexon-logopaedie-apps/',
    label: 'AGB',
  },
  nurEigentraining: {
    href: `${constants.therapistWebAppUrl}/?nur-eigentraining-einstellen`,
    label: 'Nur Eigentraining einstellen',
  },
  webApp: {
    href: `${constants.webAppUrl}`,
    label: '',
  },
  confidentiality: {
    href: 'https://neolexon.de/wp-content/uploads/schweigepflichtsentbindung_neolexon_aphasie.pdf',
    label: 'Schweigepflichtsentbindung',
  },
};
